import { Routes } from '~/router/routes'
import { useSalesCaseAPI } from '~/http/sales/sales-case/sales-case'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const leadToSalesCase = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const leadId = Number(to.params.leadId)

  if (!leadId) {
    return next({ name: Routes.SALES_CASES_INDEX })
  }

  const salesCaseAPI = useSalesCaseAPI()

  try {
    const { salesCaseId } = await salesCaseAPI.findByLead(leadId)

    if (salesCaseId === null) {
      return next({ name: Routes.SALES_CASES_INDEX })
    }

    return next({ name: Routes.SALES_CASES_TABLE, query: { salesCaseId } })
  } catch {
    return next({ name: Routes.SALES_CASES_INDEX })
  }
}

export default leadToSalesCase
